import { connect } from 'react-redux'
import { Card } from 'semantic-ui-react'

import BillingRunsListItem from 'components/superuser/billing/BillingRunsListItem'
import EntitiesList from 'components/entities/EntitiesList'
import TriggerBillingRunAction from 'components/superuser/billing/TriggerBillingRunAction'

import { getBillingRuns } from 'selectors/billing'

const mapStateToProps = (state, ownProps) => ({
  entities: getBillingRuns(state, ownProps),
  entityName: 'billingRun',
  item: BillingRunsListItem,
  listComponent: Card.Group,
  loading: state.meta?.billingRun?.loading,
  error: state.meta?.billingRun?.error,
  title: 'Billing runs',
  extraActions: TriggerBillingRunAction
})

export default connect(mapStateToProps)(EntitiesList)
